import React from 'react';
import useTranslation from '../../hooks/useTranslation';
import useSelectedDeck from '../../hooks/useSelectedDeck';
import QuizList from '../../components/QuizList/QuizList';
import CardList from "../../components/CardList/CardList";
import WordList from "../../components/WordList/WordList";

const ListPage = () => {
    const { t } = useTranslation();
    const selectedDeck = useSelectedDeck();

    // selectedDeck инициализируется null (deckReducer), undefined не бывает —
    // отдельной ветки со спиннером не нужно
    if (!selectedDeck) {
        return <div>{t('deck.selectToViewContent')}</div>;
    }

    const selectedType = selectedDeck.type;

    const renderContentForm = () => {
        switch (selectedType) {
            case 'QUIZ':
                return <QuizList />;
            case 'CARD':
                return <CardList />;
            case 'WORD':
                return <WordList/>;
            default:
                return <div>{t('deck.selectValidType')}</div>;
        }
    };

    return (
        <div style={{ width: '100%', padding: '0px' }}>
            <div style={{ marginTop: '10px', width: '100%' }}>
                {renderContentForm()}
            </div>
        </div>
    );
};

export default ListPage;
